import "./AudienceSection.css";

const HotelIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M3 21V8l9-5 9 5v13M9 21v-6h6v6M9 11h.01M15 11h.01"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const SpaIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M12 22c-4-4-7-7-7-12a7 7 0 0114 0c0 5-3 8-7 12zM12 13a3 3 0 100-6 3 3 0 000 6z"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const WellnessIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M12 21s-7-4.5-7-11a5 5 0 019-3 5 5 0 019 3c0 6.5-7 11-7 11h-4z"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const RetreatIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M3 21h18M5 21V9l7-5 7 5v12M9 21v-6h6v6"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const YogaIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="2" />
		<path
			d="M12 7v6M5 11l7 2 7-2M8 21l4-8 4 8"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const AUDIENCES = [
	{
		Icon: HotelIcon,
		title: "Hotels & Resorts",
		desc: "Elevate every guest touchpoint from check-in to turndown.",
		color: "#6B9E8D",
	},
	{
		Icon: SpaIcon,
		title: "Spas",
		desc: "Curated soundscapes for treatment rooms and relaxation lounges.",
		color: "#8B7B9D",
	},
	{
		Icon: WellnessIcon,
		title: "Wellness Centers",
		desc: "A calm, consistent atmosphere across every wellness space.",
		color: "#C9A876",
	},
	{
		Icon: YogaIcon,
		title: "Yoga Studios",
		desc: "Practice-aware music for meditation, vinyasa, and stillness.",
		color: "#7EBBA3",
	},
	{
		Icon: RetreatIcon,
		title: "Retreat Facilities",
		desc: "Immersive, intentional sound for transformative stays.",
		color: "#C9A5A0",
	},
];

const AudienceSection = () => (
	<section className="audience-section">
		<p className="audience-intro">
			BodhiStreams is a professional wellness music streaming platform designed
			specifically for hospitality and wellness businesses — from intimate spas
			to full-scale resorts.
		</p>

		<div className="audience-grid">
			{AUDIENCES.map(({ Icon, title, desc, color }) => (
				<article
					key={title}
					className="audience-card"
					style={{ "--card-color": color }}
				>
					<span className="audience-card-icon">
						<Icon />
					</span>
					<h3 className="audience-card-title">{title}</h3>
					<p className="audience-card-desc">{desc}</p>
				</article>
			))}
		</div>
	</section>
);

export default AudienceSection;
